import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    name: 'profile',
    path: 'profile',
    component: () => import('./views/ProfileView.vue'),
    props: route => ({ redirectTo: route.query.return_to ?? 'hear' }),
  },
  {
    name: 'hear',
    path: 'hear',
    component: () => import('./views/HearView.vue'),
  },
  {
    name: 'download',
    path: 'downloads',
    component: () => import('./views/DownloadView.vue'),
  },
  {
    name: 'invite',
    path: 'invite',
    alias: ['invite_members', 'invite_collaborators'],
    component: () => import('./views/InviteView.vue'),
    props: () => ({ redirectTo: 'profile' }),
  },
];
